import { TurnsOnOptionsType } from './types';

export const TURNS_ON_OPTIONS: TurnsOnOptionsType = [
  {
    id: 'feminine_body_surprise',
    title: 'Feminine body with a surprise',
  },
  {
    id: 'teasing_flirting',
    title: 'Teasing and flirting',
  },
  {
    id: 'toned_body',
    title: 'Toned body',
  },
  {
    id: 'lingerie_heels',
    title: 'Lingerie and heels',
  },
];
